import * as React from 'react';

const css = require('./page-number.css').default;

export function PageNumber({ style, pns }: {
    style?: React.CSSProperties,
    pns: [number, number],
}) {
    return (
    <div id={css.main} style={style}>
        <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
        }}>
            <div className={css.pn} style={{ left: '30px' }}>{pns[0]}</div>
            <div className={css.pn} style={{ right: '30px' }}>{pns[1]}</div>
        </div>
    </div>);
}
